module.exports = __webpack_public_path__ + "static/media/AboutAsia.946a1dbd.png";